import { SortOrder } from '@/enums';
import { axiosClient } from '@/hooks';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchProvinces = createAsyncThunk(
  'provinces/fetchProvinces',
  async (
    {
      page,
      limit,
      orderBy,
      sortOrder,
      search
    }: {
      page: number;
      limit: number;
      orderBy?: string;
      sortOrder?: SortOrder;
      search?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosClient.get(`/provinces`, {
        params: {
          page,
          limit,
          ...(orderBy && { orderBy }),
          ...(sortOrder && { sortOrder }),
          ...(search && { search })
        }
      });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
